import { Badge } from "./ui/badge";
import { statusBadge } from "../lib/constants";

export const StatusBadge = ({ status, label, testId, className = "" }) => (
  <Badge
    data-testid={testId}
    variant="outline"
    className={`${statusBadge(status)} font-medium text-xs px-2.5 py-0.5 rounded-full border ${className}`}
  >
    {label || status}
  </Badge>
);
